import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import AuthApi from "./Services/Authapi";
import ls from "local-storage";

const PermissionCheck = () => {
  const intervalRef = useRef(null);
  const history = useHistory();
  const retryCountRef = useRef(0);
  const maxRetries = 3;
  const getLoginRedirectPath = () => {
    try {
      const storedRoute = window.sessionStorage.getItem("postLogoutLoginRoute");
      return ["/login"].includes(storedRoute)
        ? storedRoute
        : "/login";
    } catch (error) {
      return "/login";
    }
  };

  useEffect(() => {
    const checkPermissions = async () => {
      if (
        window.location && 
        (
          window.location.pathname === "/login" ||
          window.location.pathname === "/Forgotpassword"
        )
      ) {
        return;
      }
      try {
        const res = await AuthApi.checkAuth();
        if (!res || res.status === false) {
          // Increment retry count before setting authToken to false
          retryCountRef.current += 1;
          
          // Only set authToken to false after multiple consecutive failures
          if (retryCountRef.current >= maxRetries) {
            ls.set("authToken", false);
            history.push(getLoginRedirectPath());
            return;
          }
          // Don't redirect on first few failures - just log
          console.warn(`Auth check failed (attempt ${retryCountRef.current}/${maxRetries})`);
          return;
        }
        
        // Reset retry count on successful auth check
        retryCountRef.current = 0;
        
        // Store latest userAccess in local storage
        if (res.data?.userAccess) {
          ls.set("userAccess", res.data.userAccess);
        }
        // Check if userAccess exists and has permissions
        const userAccess = res.data?.userAccess;
        if (!userAccess || userAccess.length === 0) {
          ls.set("authToken", false);
          history.push(getLoginRedirectPath());
          return;
        }
      } catch (error) {
        console.error("Error in permission check:", error);
        // Don't immediately set authToken to false on network errors
        retryCountRef.current += 1;
        if (retryCountRef.current >= maxRetries) {
          ls.set("authToken", false);
          history.push(getLoginRedirectPath());
        }
      }
    };

    // Initial check
    checkPermissions();

    // Set interval for every 60 seconds
    intervalRef.current = setInterval(checkPermissions, 60000);

    // Cleanup on unmount
    return () => clearInterval(intervalRef.current);
  }, [history]);

  return null; // This component does not render anything
};

export default PermissionCheck;

